/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAnalyticsDashboardViewerResponse } from '../../models/get-analytics-dashboard-viewer-response';

export interface GetAnalyticsDashboardViewer$Params {
}

export function getAnalyticsDashboardViewer(http: HttpClient, rootUrl: string, params?: GetAnalyticsDashboardViewer$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAnalyticsDashboardViewerResponse>> {
  const rb = new RequestBuilder(rootUrl, getAnalyticsDashboardViewer.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAnalyticsDashboardViewerResponse>;
    })
  );
}

getAnalyticsDashboardViewer.PATH = '/api/user/analytics/dashboard-viewer';
